/** Mirrors server/src/lib/faqLanguage.ts — keep in sync for dashboard display. */
const JUDGE_ONLY_NO_REFERENCE_EN = "(No verified reference — judge-only)";
const JUDGE_ONLY_NO_REFERENCE_HY = "(Ստուգված հղում չկա — միայն գնահատող)";

export function isSyntheticJudgeOnlyReference(text: string | null | undefined): boolean {
  if (text == null) return true;
  const trimmed = text.trim();
  if (!trimmed) return true;
  if (trimmed === JUDGE_ONLY_NO_REFERENCE_EN || trimmed === JUDGE_ONLY_NO_REFERENCE_HY) {
    return true;
  }
  // Legacy parser fallbacks that were shown as "Reference answer" in the modal.
  if (trimmed.startsWith("Answer in English, address the question directly")) return true;
  if (trimmed.startsWith("Պատասխանը պետք է լինի հայերեն")) return true;
  return false;
}

export function caseEvaluationBasis(
  expectedOutput: unknown,
): "verified_reference" | "judge_only" | null {
  if (!expectedOutput || typeof expectedOutput !== "object") return null;
  const basis = (expectedOutput as { evaluation_basis?: unknown }).evaluation_basis;
  if (basis === "verified_reference" || basis === "judge_only") return basis;
  return null;
}
